var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,19.988v15.026c0,2.181-3.122,4.963-5.301,4.997l-33.132.015c-2.656-.092-5.567-2.896-5.567-5.574v-14.323l.14-.14h43.86ZM11.524,28.061c-2.264.717-1.95,3.73.457,3.992,3.871-.221,8.146.336,11.97.01,2.644-.225,2.902-3.331.461-4.016l-12.889.014ZM37.447,31.469c1.934-1.922-1.08-4.766-2.873-2.826-1.783,1.928,1.082,4.606,2.873,2.826Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46,16.056H2.14l-.14-.14v-2.34c0-2.398,2.508-5.089,4.863-5.435,11.375-.246,22.828-.185,34.21-.031,2.019.132,4.926,2.898,4.926,4.904v3.043Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayment);
export default __webpack_public_path__ + "static/media/icon-payment.24949269f8524b9446c7f78d7ea03316.svg";
export { ForwardRef as ReactComponent };